import getCallResult from './CallResult';
export default class IdentityAPI {
    authenticate(identityProviderId, initIntegrationUrl, urlHash) {
        const url = `${window.location.origin}/identity/${identityProviderId}/Authenticate`;
        return this.sendRequest(
            url,
            'POST',
            true,
            JSON.stringify({ initIntegrationUrl: initIntegrationUrl, urlHash: urlHash })
        );
    }

    sendRequest(url, method, isAsync, data, timeout) {
        return new Promise((resolve, reject) => {
            const request = new XMLHttpRequest();
            request.onreadystatechange = function () {
                if (request.readyState === 4) {
                    const result = getCallResult({
                        data: JSON.parse(request.responseText),
                        status: request.status
                    });
                    if (request.status === 200 && request.responseText !== '') {
                        resolve(result);
                    } else {
                        reject(result);
                    }
                }
            };

            request.open(method, url, isAsync);

            request.timeout = timeout;
            request.setRequestHeader('Content-Type', 'application/json');

            request.send(data);
        });
    }
}
